export default {
    init() {
        // JavaScript to be fired on the direct debit form page

        let map;
        let zoomLevel = 9;
        let windowWidth = $(window).width();

        if(windowWidth < 768){
            zoomLevel = 8;
        }

        if(windowWidth > 991 && windowWidth < 1200){
            zoomLevel = 8;
        }

        function initMap() {

            map = new google.maps.Map(document.getElementById('map'), { // eslint-disable-line
                center: {lat: 54.672420, lng: -2.1},
                zoom: zoomLevel,
                panControl: false,
                zoomControl: false,
                scaleControl: false,
                disableDefaultUI: true,
                styles: [
                    {
                        "featureType": "administrative.land_parcel",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "administrative.locality",
                        "stylers": [
                            {
                                "visibility": "simplified",
                            },
                        ],
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on",
                            },
                        ],
                    },
                    {
                        "featureType": "administrative.province",
                        "stylers": [
                            {
                                "visibility": "on",
                            },
                        ],
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "road.arterial",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "road.local",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off",
                            },
                        ],
                    },
                ],
            });

            let iconURL = '/app/themes/gnaas/resources/assets/images/map-pin.png';
            let image = {
                url: iconURL,
                size: new google.maps.Size(71, 100), // eslint-disable-line
                origin: new google.maps.Point(0, 0), // eslint-disable-line
                anchor: new google.maps.Point(17, 34), // eslint-disable-line
                scaledSize: new google.maps.Size(30, 40), // eslint-disable-line
            };

            new google.maps.Marker({ // eslint-disable-line
                position: new google.maps.LatLng(54.523402, -1.558067), // eslint-disable-line
                icon: image,
                map: map,
            });

            new google.maps.Marker({ // eslint-disable-line
                position: new google.maps.LatLng(54.612438, -1.581650), // eslint-disable-line
                icon: image,
                map: map,
            });

            new google.maps.Marker({ // eslint-disable-line
                position: new google.maps.LatLng(54.691206, -2.662418), // eslint-disable-line
                icon: image,
                map: map,
            });

        }

        $(document).ready(function(){
            initMap();
        });

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js